import Vue from 'vue'
import Vuex from 'vuex'
import axios from "axios";

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    infoDay: null,
    infoForeCast: null,
    isReady : false
  },
  mutations: {
    updateContent(state, payload) {
      state.isReady = payload
    },
    updateWeather(state, ville) {
      axios
        .get(
          `https://api.openweathermap.org/data/2.5/weather?q=${ville}&lang=fr&units=metric&appid=8469952240e30855b481efa25df3d378`
        )
        .then(res => (state.infoDay = res));
    },
    updateForeCast(state, payload) {
      axios
        .get(
          `https://api.openweathermap.org/data/2.5/onecall?lat=${payload.lat}&lon=${payload.lon}&exclude=current,hourly&lang=fr&units=metric&appid=8469952240e30855b481efa25df3d378`
        )
        .then(res => (state.infoForeCast = res, state.infoForeCast.data.daily.splice(0,1)))
    }
  },
  actions: {
  },
  modules: {
  }
})
